import React from "react";
import PropTypes from "prop-types";
import { presets } from "config/images";
import ImageComponent, { PLACEHOLDER } from "./ImageComponent";

const ImageSkeleton = ({
  alt,
  format,
  appearance,
  placeholderSrc = PLACEHOLDER,
  ...imgProps
}) => {
  const ratio = presets[format]
    ? presets[format].height / presets[format].width
    : undefined;

  return (
    <ImageComponent
      imgProps={imgProps}
      appearance={appearance}
      images={{
        loading: {
          src: PLACEHOLDER,
          sources: [],
        },
      }}
      ratio={ratio}
      alt=""
      status="loading"
    />
  );
};

ImageSkeleton.propTypes = {
  format: PropTypes.oneOf(Object.keys(presets)),
  appearance: PropTypes.oneOf(["default", "full", "rounded", "full-rounded"]),
};

ImageSkeleton.defaultProps = {
  appearance: "default",
};

export default ImageSkeleton;
